/*
 * Slovenian — the console's first language. `en.ts` is checked against this file's shape
 * (`MessageSchema`), so a key missing from either fails the type-check.
 *
 * Plural messages carry Slovenian's four forms — ednina | dvojina | 3–4 | 5+ (`libs/i18n`).
 */
const sl = {
    general: {
        add:       'Dodaj',
        edit:      'Uredi',
        delete:    'Izbriši',
        cancel:    'Prekliči',
        close:     'Zapri',
        confirm:   'Potrdi',
        save:      'Shrani',
        saving:    'Shranjujem …',
        back:      'Nazaj',
        refresh:   'Osveži',
        searching: 'Iščem …',
        sign_out:  'Odjava',
        total:     'Skupaj: {n}',
        yes:       'da',
        no:        'ne',
    },
    brand: {
        product_name: 'Portal',
        tagline:      'Galerija Gosposka',
    },
    nav: {
        dashboard:       'Pregled',
        group_dobavnice: 'Dobavnice',
        uploads:         'Nalaganje',
        notes:           'Seznam',
        exports:         'Izvoz',
        suppliers:       'Dobavitelji',
        catalogs:        'Šifranti',
        group_inventura: 'Inventura',
        inventories:     'Inventure',
        group_admin:     'Administracija',
        users:           'Uporabniki',
        roles:           'Vloge',
        settings:        'Nastavitve',
        profile:         'Profil',
        version_web:     'Konzola {version}',
        version_api:     'API {version}',
        articles: 'Artikli šanka',
        group_prenos: 'Prenos',
        transfers: 'Prenosnice',
        transfer_new: 'Nova prenosnica',
        group_urniki: 'Urniki',
        schedule:     'Urnik',
        my_schedule:  'Moj urnik',
        employees:    'Zaposleni',
        group_eracuni: 'E-računi',
        eracuni_log:   'Dnevnik',
    },
    layout: {
        open_menu:  'Odpri meni',
        close_menu: 'Zapri meni',
    },
    color_mode: {
        switch_to_light: 'Preklopi na svetli način',
        switch_to_dark:  'Preklopi na temni način',
    },
    locale: {
        label: 'Jezik',
        sl:    'Slovenščina',
        en:    'English',
    },
    date: {
        clear: 'Počisti datum',
        pick:  'Izberi datum',
    },
    auth: {
        username:      'Uporabniško ime',
        password:      'Geslo',
        password_show: 'Pokaži geslo',
        password_hide: 'Skrij geslo',
        sign_in:       'Prijava',
        failed:        'Napačno uporabniško ime ali geslo.',
    },
    errors: {
        generic_error:     'Prišlo je do napake.',
        internal:          'Napaka na strežniku. Poskusite znova čez nekaj trenutkov.',
        invalid_data:      'Podatki niso veljavni.',
        not_found:         'Ni najdeno.',
        unauthorized:      'Seja je potekla. Prijavite se znova.',
        failed_to_insert:  'Zapisa ni bilo mogoče shraniti.',
        forbidden:         'Za to nimate pravic.',
        too_many_attempts: 'Preveč neuspelih prijav. Poskusite znova čez nekaj minut.',
        conflict:          'Zapis se je medtem spremenil ali pa ta korak v tem stanju ni mogoč.',
        duplicate:         'Tak zapis že obstaja.',
        ai_not_configured: 'AI ni nastavljen (ni ključa ali je izklopljen). Uredite ga v Nastavitve → AI.',
        ai_failed:         'Klic AI ni uspel.',
        ai_failed_reply:   'Klic AI ni uspel: {reply}',
        last_admin:        'Zadnjemu aktivnemu skrbniku ne morete odvzeti pravice do uporabnikov, ga deaktivirati ali odstraniti.',
        cannot_confirm:    'Dobavnice ni mogoče potrditi, dokler so odprte napake v preverjanjih.',
        import_unreadable: 'Datoteke ni mogoče prebrati (napačna oblika ali manjka obvezen stolpec).',
        wrong_password:    'Trenutno geslo ni pravilno.',
        inventory_open:    'Za ta lokal je inventura že odprta (štetje ali pregled).',
        mail_failed:       'E-pošte ni bilo mogoče poslati.',
        mail_failed_reply: 'E-pošte ni bilo mogoče poslati: {reply}',
        on_load:           'Podatkov ni bilo mogoče naložiti.',
        on_add:            'Napaka pri dodajanju.',
        on_edit:           'Napaka pri shranjevanju.',
        on_delete:         'Napaka pri brisanju.',
    },
    success: {
        add:    'Dodano.',
        edit:   'Shranjeno.',
        delete: 'Izbrisano.',
    },
    validation: {
        required:   'To polje je obvezno.',
        email:      'Neveljaven e-poštni naslov.',
        too_long:   'Predolgo.',
        min_length: 'Vsaj {n} znakov.',
    },
    reason: {
        label: 'Razlog',
    },
    module: {
        admin:     'Administracija',
        dobavnice: 'Dobavnice',
        inventura: 'Inventura',
        prenos: 'Prenos',
        urniki: 'Urniki',
        eracuni: 'E-računi',
    },
    permission: {
        admin_users:        'Uporabniki in vloge',
        admin_settings:     'Nastavitve AI in pošte',
        dobavnice_view:     'Vpogled',
        dobavnice_upload:   'Nalaganje skenov',
        dobavnice_review:   'Pregled in potrjevanje',
        dobavnice_export:   'Izvoz v računovodstvo',
        dobavnice_catalogs: 'Urejanje šifrantov',
        dobavnice_settings: 'Nastavitve izvoza',
        inventura_view:     'Vpogled',
        inventura_count:    'Štetje',
        inventura_manage:   'Vodenje inventur',
        inventura_export:   'Prenos poročila Excel',
        inventura_articles: 'Artikli šanka',
        prenos_view: 'Vpogled',
        prenos_create: 'Izdajanje prenosnic',
        prenos_receive: 'Potrjevanje prejema',
        prenos_manage: 'Vodenje prenosov',
        urniki_view: 'Vpogled',
        urniki_edit: 'Urejanje urnikov',
        eracuni_view:   'Vpogled v dnevnik',
        eracuni_manage: 'Upravljanje',
    },
    permission_help: {
        admin_users:        'Ustvarja in ureja uporabnike ter vloge.',
        admin_settings:     'Nastavi ključ Anthropic, model in vzporedno branje ter odhodno pošto portala.',
        dobavnice_view:     'Bere dobavnice, nalaganja, izvoze in šifrante.',
        dobavnice_upload:   'Naloži skene in ponovi neuspelo branje.',
        dobavnice_review:   'Popravlja, potrjuje, zavrača, ponovno odpira in ponovno bere dobavnice.',
        dobavnice_export:   'Ustvari, prenese in prekliče izvoz XML.',
        dobavnice_catalogs: 'Ureja in uvaža materiale, dobavitelje in skladišča; briše povezave.',
        dobavnice_settings: 'Ureja obliko izvoza XML (DDV skupine, decimalke, kodiranje).',
        inventura_view:     'Bere inventure; knjižne količine le skupaj z vodenjem inventur.',
        inventura_count:    'Šteje: doda in odstrani svoje vnose, doda artikel, ki ga ni na seznamu, preda inventuro v pregled.',
        inventura_manage:   'Odpre inventuro šanka, vidi začetno stanje, dodatno, prodajo in rezultat, uvozi prodajo, popravlja, zaključi, ponovno odpre, prekliče; nastavitve.',
        inventura_export:   'Prenese poročilo inventure v Excelu.',
        inventura_articles: 'Ureja artikle šanka: seznam in vrstni red po lokalih, združevanje, uvoz popisnega lista.',
        prenos_view: 'Bere prenosnice svojih lokalov.',
        prenos_create: 'Pripravi, uredi (osnutek), izda in prekliče svoje prenosnice.',
        prenos_receive: 'Potrdi prejem prenosnice v svojem lokalu.',
        prenos_manage: 'Prekliče katerokoli prenosnico in bere vse.',
        urniki_view: 'Vidi objavljene urnike in svoje izmene.',
        urniki_edit: 'Ureja izmene, dneve, zaposlene in nastavitve urnikov; vidi osnutke in jih objavi.',
        eracuni_view:   'Bere dnevnik poslanih e-računov in stanje pregleda mape.',
        eracuni_manage: 'Ureja nastavitve E-računov in znova pošlje datoteko iz dnevnika.',
    },
    dashboard: {
        review:          'V pregledu',
        confirmed:       'Potrjene',
        exported:        'Izvožene',
        rejected:        'Zavrnjene',
        uploads_pending: 'V branju',
        uploads_failed:  'Neuspela branja',
        recent_uploads:  'Zadnja nalaganja',
        no_uploads:      'Ni še nobenega nalaganja.',
        welcome:         'Pozdravljeni, {name}',
        no_modules:      'Za zdaj nimate dostopa do nobenega modula. Za dostop se obrnite na skrbnika.',
        inventura_counting: 'V štetju',
        inventura_review:   'V pregledu',
        inventura_closed:   'Zaključene (30 dni)',
        prenos_to_receive: 'Čaka na moj prejem',
        prenos_my_drafts: 'Moji osnutki',
        prenos_in_transit: 'Na poti',
        today_title:        'Danes',
        my_shift:           'Moja izmena danes',
        receive_goods:      'Prevzemi blago',
        you_are_first:      'Prvi v izmeni ste vi',
        receive_action:     'Prevzemi',
        open_transfer:      'Odpri',
        bar_count_today:    'Popis šanka danes',
        inventory_open:     'Inventura {number} je odprta.',
        inventory_not_open: 'Inventura še ni odprta.',
        count_action:       'Popis',
        open_inventory:     'Odpri inventuro',
        urniki_intro:       'Tu so vaše izmene in urnik tedna.',
    },
    upload_status: {
        queued:  'V vrsti',
        reading: 'Berem',
        done:    'Prebrano',
        failed:  'Neuspešno',
    },
    upload: {
        title:             'Naloži dobavnice',
        subtitle:          'Skeni PDF, JPG ali PNG; ena datoteka ima lahko več dobavnic.',
        drop_hint:         'Spustite datoteke kamorkoli na stran ali kliknite tukaj',
        drop_here:         'Spustite datoteke za nalaganje',
        drop_limits:       'PDF, JPG, PNG · do {files} datotek · največ {mb} MB vsaka',
        sending:           'Nalagam {done} od {total} …',
        sent:              'Naložena {n} datoteka. | Naloženi {n} datoteki. | Naložene {n} datoteke. | Naloženih {n} datotek.',
        refused_title:     'Zavrnjena {n} datoteka | Zavrnjeni {n} datoteki | Zavrnjene {n} datoteke | Zavrnjenih {n} datotek',
        refused_type:      'ni PDF, JPG ali PNG',
        refused_size:      'večja od {mb} MB',
        refused_empty:     'prazna datoteka',
        refused_duplicate: 'ta datoteka je že naložena',
        refused_network:   'povezava je prekinjena, poskusite znova',
        refused_other:     'zavrnjena',
        force:             'Naloži vseeno',
        list_title:        'Nalaganja',
        status_filter:     'Stanje',
        status_all:        'Vsa stanja',
        empty:             'Ni nalaganj.',
        file:              'Datoteka',
        uploaded:          'Naloženo',
        status:            'Stanje',
        notes:             'Dobavnice',
        note_n:            'Dobavnica {n}',
        notes_count:       '{n} dobavnica | {n} dobavnici | {n} dobavnice | {n} dobavnic',
        pages:             '{n} stran | {n} strani | {n} strani | {n} strani',
        retry:             'Ponovi branje',
        retry_started:     'Branje se je ponovno začelo.',
        retry_failed:      'Branja ni bilo mogoče ponoviti.',
        share_badge:       'Skener',
        share_badge_title: 'Iz mape skenerja: {name}',
        share_status:      'zadnji pregled {time}, danes {files}',
        share_never:       'še ni bilo pregleda',
        share_no_unit:     'Brez enote',
        share_files:       '{n} datoteka | {n} datoteki | {n} datoteke | {n} datotek',
        share_refused:     'zavrnjenih danes: {n}',
        share_error:       'Zadnja napaka: {error}',
    },
    note_status: {
        review:    'V pregledu',
        confirmed: 'Potrjena',
        exported:  'Izvožena',
        rejected:  'Zavrnjena',
    },
    note_status_tab: {
        review:    'V pregledu',
        confirmed: 'Potrjene',
        exported:  'Izvožene',
        rejected:  'Zavrnjene',
    },
    document_type: {
        dobavnica:       'Dobavnica',
        racun:           'Račun',
        racun_dobavnica: 'Račun-dobavnica',
        drugo:           'Drugo',
    },
    line_match: {
        mapped:    'Naučeno',
        confirmed: 'Potrjeno',
        suggested: 'Predlog',
        none:      'Ni materiala',
    },
    check: {
        supplier_missing:       'Dobavitelj manjka.',
        supplier_unknown:       'Davčne številke {tax_id} ni v šifrantu dobaviteljev.',
        tax_id_invalid:         'Davčna številka {tax_id} ni veljavna (kontrolna števka).',
        number_missing:         'Številka dokumenta manjka.',
        date_missing:           'Datum dokumenta manjka.',
        date_future:            'Datum dokumenta ({date}) je v prihodnosti.',
        warehouse_missing:      'Skladišče ni izbrano.',
        line_material_missing:  'Vrstica {line}: material ni izbran ali predlog ni potrjen.',
        line_vat_group_missing: 'Vrstica {line}: skupina DDV manjka.',
        line_quantity_missing:  'Vrstica {line}: količina manjka.',
        sum_mismatch:           'Vsota vrstic ({lines}) se ne ujema z neto zneskom dokumenta ({header}).',
        sum_mismatch_no_header: 'Neto znesek dokumenta manjka (vsota vrstic {lines}).',
        line_net_mismatch:      'Vrstica {line}: količina × cena − rabat da {expected}, natisnjeni neto je {net}.',
        duplicate:              'Dobavnica z isto davčno številko in številko že obstaja.',
        no_lines:               'Dobavnica nima vrstic.',
        buyer_as_supplier:      'Kot dobavitelj je vpisana Galerija Gosposka (kupec, {tax_id}).',
        unit_factor_missing:    'Vrstica {line}: enota dobavitelja ({unit}) ni enota materiala ({material_unit}) — vpišite, koliko {material_unit} je 1 {unit}.',
    },
    confidence: {
        high:   'zelo verjetno',
        medium: 'verjetno',
        low:    'ugibanje',
    },
    factor_source: {
        auto:    'samodejno',
        mapping: 'naučeno',
        set:     'vpisano',
    },
    note: {
        list_title:         'Dobavnice',
        search:             'Išči po številki ali dobavitelju',
        all_warehouses:     'Vsa skladišča',
        all_suppliers:      'Vsi dobavitelji',
        from:               'Od datuma',
        to:                 'Do datuma',
        clear_filters:      'Počisti filtre',
        empty:              'Ni dobavnic.',
        date:               'Datum',
        number:             'Številka',
        no_number:          '(brez številke)',
        supplier:           'Dobavitelj',
        warehouse:          'Skladišče',
        warehouse_pick:     'Izberite skladišče',
        net_total:          'Neto',
        vat_total:          'DDV',
        gross_total:        'Bruto',
        checks:             'Preverjanja',
        checks_ok:          'Vsa preverjanja so v redu.',
        checks_stale:       'Osvežijo se ob shranjevanju.',
        errors_count:       '{n} napaka | {n} napaki | {n} napake | {n} napak',
        warnings_count:     '{n} opozorilo | {n} opozorili | {n} opozorila | {n} opozoril',
        status:             'Stanje',
        read_by:            'Prebral {model}, {when}',
        edited_by:          'nazadnje urejal {name}, {when}',
        previous:           'Prejšnja v pregledu',
        next:               'Naslednja v pregledu',
        position:           '{n} / {total}',
        in_review:          'V pregledu: {total}',
        header_title:       'Glava dokumenta',
        supplier_tax_id:    'Davčna št. / ID za DDV dobavitelja',
        supplier_name:      'Naziv dobavitelja',
        supplier_matched:   'V šifrantu',
        supplier_unmatched: 'Ni v šifrantu',
        delivery_address:   'Naslov dostave: {address}',
        buyer:              'Kupec na dokumentu: {buyer}',
        warehouse_from_folder: 'Enota mape skenerja, iz katere je sken prišel.',
        document_type:      'Vrsta dokumenta',
        service_date:       'Datum opravljene storitve',
        ai_notes:           'Opombe pri branju',
        lines_title:        'Vrstice ({n})',
        no_lines:           'Ni vrstic.',
        sum_lines:          'Vrstice {lines} · glava {header}',
        scan_title:         'Izvirni sken',
        scan_pages:         'Strani {pages}',
        scan_open:          'Odpri v novem zavihku',
        scan_zoom_in:       'Prava velikost',
        scan_zoom_out:      'Prilagodi širini',
        confirm:            'Potrdi',
        confirm_blocked:    'Najprej odpravite {n} napako. | Najprej odpravite {n} napaki. | Najprej odpravite {n} napake. | Najprej odpravite {n} napak.',
        confirmed:          'Dobavnica je potrjena.',
        confirm_failed:     'Dobavnice ni bilo mogoče potrditi.',
        confirmed_title:    'Potrdil {name}, {when}',
        saved:              'Shranjeno.',
        conflict:           'Dobavnico je medtem spremenil nekdo drug.',
        conflict_help:      'Naložena je trenutna različica; vaše spremembe niso shranjene.',
        gone:               'Te dobavnice ni več.',
        gone_help:          'Medtem je bila ponovno prebrana (nastala je nova) ali odstranjena. Odpiram seznam dobavnic v pregledu.',
        reject:             'Zavrni',
        reject_title:       'Zavrni dobavnico',
        reject_help:        'Zavrnjena dobavnica ne gre v izvoz. Razlog ostane zapisan.',
        rejected:           'Dobavnica je zavrnjena.',
        reject_failed:      'Dobavnice ni bilo mogoče zavrniti.',
        rejected_title:     'Zavrnjena',
        reopen:             'Odpri ponovno',
        reopen_question:    'Potrjeno dobavnico vrnem v pregled? Ne bo več pripravljena za izvoz.',
        reopened:           'Dobavnica je spet v pregledu.',
        reopen_failed:      'Dobavnice ni bilo mogoče ponovno odpreti.',
        reread:             'Ponovno preberi',
        reread_question:    'Datoteko preberem znova? Dobavnice iz te datoteke, ki so v pregledu ali zavrnjene, bodo nadomeščene; vaši popravki se izgubijo.',
        reread_started:     'Datoteka se ponovno bere.',
        reread_failed:      'Ponovnega branja ni bilo mogoče začeti.',
        exported_title:     'Izvožena',
        exported_help:      'Izvožene dobavnice ni mogoče urejati, dokler izvoz ni preklican.',
        leave_title:        'Neshranjene spremembe',
        leave_question:     'Spremembe na tej dobavnici niso shranjene. Jih zavržem?',
        leave:              'Zavrzi',
        suggest:              'Predlagaj z AI',
        suggest_running:      'Claude predlaga …',
        suggest_help:         'Claude predlaga material (in pretvorbo enot) za vrstice, ki jih strežnik ni znal povezati. Predlog velja šele, ko ga sprejmete.',
        suggest_done:         'Claude je predlagal {when}. Ponovno vprašaj za vrstice brez materiala.',
        suggest_ready:        'Claudovi predlogi so pripravljeni — preglejte in sprejmite jih.',
        suggest_failed:       'Predlogi AI niso uspeli',
        suggest_arrived:      'Claudovi predlogi so prispeli.',
        suggest_arrived_help: 'Dobavnica ima neshranjene spremembe: shranjevanje bo javilo spor in jo naložilo znova s predlogi.',
    },
    line: {
        supplier_code:        'Šifra',
        description:          'Opis',
        quantity:             'Količina',
        unit_price:           'Cena',
        discount:             'Rab. %',
        net_amount:           'Neto',
        vat_rate:             'DDV %',
        vat_group:            'Skupina DDV',
        material:             'Material',
        lot:                  'Lot {lot}',
        accept_suggestion:    'Sprejmi predlog',
        add:                  'Dodaj vrstico',
        remove_of:            'Odstrani vrstico {n}',
        description_of:       'Opis, vrstica {n}',
        supplier_code_of:     'Šifra dobavitelja, vrstica {n}',
        quantity_of:          'Količina, vrstica {n}',
        unit_price_of:        'Cena na enoto, vrstica {n}',
        discount_of:          'Rabat v odstotkih, vrstica {n}',
        net_amount_of:        'Neto znesek, vrstica {n}',
        vat_rate_of:          'Stopnja DDV, vrstica {n}',
        vat_group_of:         'Skupina DDV, vrstica {n}',
        material_of:          'Material, vrstica {n}',
        factor_missing:       'koliko?',
        factor_of:            'Koliko {material_unit} je 1 {unit}, vrstica {n}',
        converted_of:         'Količina v {unit}, vrstica {n}',
        claude_factor:        'Claude: 1 {unit} = {factor} {material_unit}',
        claude_factor_help:   'Claudov predlog pretvorbe — uporabi ga',
    },
    export: {
        pending_title:    'Pripravljeno za izvoz',
        pending_subtitle: 'Potrjene dobavnice po enotah — ena datoteka XML na enoto.',
        nothing_pending:  'Ni potrjenih dobavnic, ki bi čakale na izvoz.',
        selected:         'Izbranih {n} od {total}',
        select_all:       'Izberi vse',
        select_note:      'Izberi dobavnico {number}',
        create:           'Izvozi',
        created_toast:    'Izvoz {number} je pripravljen (dobavnic: {n}); prenos se je začel.',
        create_failed:    'Izvoza ni bilo mogoče ustvariti.',
        history_title:    'Zgodovina izvozov',
        history_empty:    'Ni še nobenega izvoza.',
        number:           'Št. izvoza',
        note_count:       'Dobavnic',
        created:          'Ustvarjen',
        state:            'Stanje',
        active:           'Veljaven',
        cancelled:        'Preklican',
        download:         'Prenesi XML',
        cancel:           'Prekliči izvoz',
        cancel_title:     'Prekliči izvoz {number}',
        cancel_help:      'Dobavnice tega izvoza ({n}) se vrnejo med potrjene. Datoteka, ki je že v računovodstvu, se ne umakne sama.',
        cancelled_toast:  'Izvoz {number} je preklican.',
        cancel_failed:    'Izvoza ni bilo mogoče preklicati.',
    },
    catalog: {
        title:              'Šifranti',
        subtitle:           'Materiali, skladišča in naučene povezave.',
        tab_materials:      'Materiali',
        tab_warehouses:     'Skladišča',
        tab_mappings:       'Povezave',
        active:             'Aktiven',
        only_active:        'Aktivni',
        all:                'Vsi',
        deactivate:         'Odstrani',
        deleted:            'Izbrisano.',
        deactivated_in_use: 'Deaktivirano (v uporabi).',
        download_csv:       'Prenesi CSV',
    },
    material: {
        search:              'Išči po šifri ali nazivu',
        pick:                'Izberite material',
        suggestions:         'Predlogi',
        catalog:             'Šifrant',
        claude:              'Claude',
        ai_suggestion:       'Predlog Claude',
        none_found:          'Ni zadetkov.',
        add:                 'Dodaj material',
        edit:                'Uredi material',
        code:                'Šifra',
        name:                'Naziv',
        unit:                'Enota',
        vat_group:           'Skupina DDV',
        active_help:         'Neaktivnega materiala ni med izbirami na dobavnicah.',
        empty:               'Ni materialov.',
        deactivate_question: 'Odstranim material {code} {name}? Če ga uporablja povezava ali dobavnica, bo le deaktiviran.',
        import_title:        'Uvoz materialov',
        import_columns:      'Stolpci: šifra, naziv, enota (em), ddv',
    },
    supplier: {
        title:               'Dobavitelji',
        subtitle:            'Šifrant dobaviteljev, s katerim strežnik prepozna dobavitelja na vsaki dobavnici.',
        search:              'Išči po davčni številki ali nazivu',
        pick:                'Izberite dobavitelja',
        none_found:          'Ni zadetkov.',
        add:                 'Dodaj dobavitelja',
        edit:                'Uredi dobavitelja',
        tax_id:              'Davčna št. / ID za DDV',
        tax_id_help:         'S predpono države, kadar jo ima: SI42034086, IT00547460311. Lahko ostane prazno.',
        tax_id_invalid:      'Neveljavna oblika (npr. SI12345678).',
        no_tax_id:           'brez davčne številke',
        name:                'Naziv',
        aliases:             'Sopomenke',
        aliases_help:        'Druga imena, pod katerimi se dobavitelj pojavlja na dokumentih (vnos ločite z Enter ali vejico).',
        address:             'Naslov',
        country:             'Država',
        country_help:        'Dvočrkovna oznaka, npr. SI, IT, AT.',
        country_invalid:     'Dve črki, npr. SI.',
        active_help:         'Neaktivnega dobavitelja strežnik ne ponuja pri prepoznavanju.',
        empty:               'Ni dobaviteljev.',
        deactivate_question: 'Odstranim dobavitelja {name}? Če ga uporablja povezava ali dobavnica, bo le deaktiviran.',
        import_title:        'Uvoz dobaviteljev',
        import_columns:      'Stolpci: davčna (ds, ddv_id), naziv, naslov, država',
        notes:               'Dobavnice dobavitelja',
        mapping_count:       'Povezav',
        mappings_title:      'Naučene povezave',
        mappings_subtitle:   'Šifre dobavitelja, ki jih je potrjevanje povezalo z našimi materiali.',
    },
    warehouse: {
        search:              'Išči skladišče',
        add:                 'Dodaj skladišče',
        edit:                'Uredi skladišče',
        code:                'Šifra',
        code_help:           'Šifra skladišča v računovodstvu; po njej se imenuje datoteka izvoza.',
        name:                'Naziv',
        keywords:            'Ključne besede',
        keywords_help:       'Besede v naslovu dostave, po katerih strežnik prepozna skladišče (velike/male črke in šumniki niso pomembni).',
        fallback:            'Rezervno skladišče',
        fallback_help:       'Velja le, če na dokumentu ni ključne besede drugega skladišča (npr. Rožmarin: »La Pizzeria Rožmarin« gre v La Pizzerio).',
        fallback_badge:      'rezervno',
        empty:               'Ni skladišč.',
        deactivate_question: 'Odstranim skladišče {name}?',
        flags: 'Uporaba',
        bar: 'Šank',
        bar_help: 'Lokal ima šank: inventura se šteje tedensko in ima svoj seznam artiklov.',
        bar_badge: 'šank',
        transfers: 'Prenos',
        transfers_help: 'Lokal je lahko izvor ali cilj prenosnice.',
        transfers_badge: 'prenos',
        main: 'Glavno skladišče',
        main_help: 'Privzeti izvor nove prenosnice; glavno je lahko le eno skladišče.',
        main_badge: 'glavno',
        color:      'Barva v urniku',
        color_help: 'S to barvo se v urniku rišejo izmene na tem lokalu.',
        unit:                    'Enota',
        unit_help:               'Ena od treh enot (La Pizzeria, Rožmarin, Poper): dobavnice in izvozi gredo po enotah, vsako drugo mesto pripada eni od njih.',
        unit_badge:              'enota',
        unit_of:                 'Enota',
        belongs_to:              'Pripada enoti',
        belongs_to_help:         'Uporabnik z omejitvijo na enoto vidi tudi njena mesta (npr. prenose v Vinoteko).',
        belongs_to_none:         'Nobeni enoti',
        deactivate_unit_warning: 'Enoti pripadajo mesta {places} — ostanejo njena.',
        unit_inactive_warning:   'Enoti pripadajo mesta {places}. Če jo izklopite, ostanejo njena; za dobavnice je ne bo več mogoče izbrati.',
        unit_members_warning:    'Enoti pripadajo mesta {places}. Najprej jih premaknite k drugi enoti, sicer strežnik spremembe ne sprejme.',
    },
    mapping: {
        search:          'Išči po šifri ali materialu',
        empty:           'Ni naučenih povezav.',
        supplier:        'Dobavitelj',
        key:             'Šifra / opis dobavitelja',
        by_description:  'Po opisu vrstice (dobavitelj šifre ne tiska)',
        material:        'Naš material',
        uses:            'Uporab',
        last_used:       'Zadnjič',
        delete_question: 'Izbrišem povezavo {key} → {material}? Naslednja potrditev jo lahko spet nauči.',
        factor:          'Pretvorba',
        factor_value:    '1 {unit} = {factor} {material_unit}',
        factor_auto:     'po enotah',
    },
    import: {
        button:             'Uvozi',
        description:        'Datoteka CSV (ločilo ; ali ,) ali XLSX s prvo vrstico glave.',
        file:               'Datoteka',
        file_help:          'CSV v UTF-8 ali Windows-1250 ali XLSX.',
        file_required:      'Izberite datoteko.',
        drop:               'Spustite datoteko sem ali kliknite',
        mode:               'Način',
        mode_upsert:        'Dodaj in posodobi',
        mode_upsert_help:   'Novi zapisi se dodajo, obstoječi posodobijo; ostali ostanejo.',
        mode_replace:       'Zamenjaj',
        mode_replace_help:  'Kot zgoraj, zapisi, ki jih ni v datoteki, pa se deaktivirajo.',
        start:              'Uvozi',
        failed:             'Uvoz ni uspel.',
        created:            'Dodanih',
        updated:            'Posodobljenih',
        deactivated:        'Deaktiviranih',
        skipped:            'Preskočena {n} vrstica | Preskočeni {n} vrstici | Preskočene {n} vrstice | Preskočenih {n} vrstic',
        row:                'vrst. {row}',
    },
    inventory_status: {
        counting:  'Štetje',
        review:    'Pregled',
        closed:    'Zaključena',
        cancelled: 'Preklicana',
    },
    inventory_status_tab: {
        counting:  'Štetje',
        review:    'Pregled',
        closed:    'Zaključene',
        cancelled: 'Preklicane',
    },
    inventory_kind: {
        full:         'Polna',
        partial:      'Delna',
        full_help:    'Artikel, ki ga nihče ne prešteje, se ob zaključku šteje kot 0.',
        partial_help: 'Artikli, ki jih nihče ne prešteje, se ob zaključku izpustijo iz rezultata.',
    },
    inventory: {
        list_title:       'Inventure',
        list_subtitle:    'Tedenski popis šankov — začetno, dodatno, popis, prodaja in rezultat.',
        new:              'Nova inventura',
        warehouse:        'Lokal',
        all_warehouses:   'Vsi lokali',
        from:             'Od datuma',
        to:               'Do datuma',
        empty:            'Ni inventur.',
        number:           'Številka',
        date:             'Datum',
        kind:             'Vrsta',
        status:           'Stanje',
        counted:          'Prešteto',
        counted_of:       '{counted} / {total}',
        difference_value: 'Razlika v vrednosti',
        note:             'Opomba',
        period: 'Obdobje',
        period_from: 'Obdobje od',
        period_to: 'Obdobje do',
    },
    inventory_create: {
        title:             'Nova inventura',
        description:       'Seznam artiklov lokala postane seznam za štetje; začetno stanje je zadnji zaključeni popis.',
        warehouse_pick:    'Izberite lokal',
        no_warehouses:     'Ni lokala s šankom, za katerega bi lahko odprli inventuro.',
        file:              'Izvoz zaloge',
        file_help:         'Excel (XLSX) ali CSV s prvo vrstico glave, največ 10 MB.',
        file_hint:         'XLSX ali CSV',
        previewing:        'Berem datoteko …',
        preview_title:     'Prvih {shown} od {total} vrstic',
        mapping_title:     'Povezava stolpcev',
        mapping_help:      'Kateri stolpec datoteke je kaj. Šifra, naziv in količina so obvezni.',
        no_column:         '— ni —',
        save_mapping:      'Zapomni si povezavo stolpcev',
        save_mapping_help: 'Naslednji uvoz jo predlaga sam.',
        open_one:          'Odprta je {number} ({status}, {date}). Najprej jo zaključite ali prekličite.',
        open_it:           'Odpri inventuro',
        create:            'Ustvari',
        created:           'Inventura {number} je odprta.',
        report_rows:       'Vrstic',
        report_items:      'Artiklov',
        report_skipped:    'Preskočenih',
        open:              'Odpri inventuro',
        wrong_type:        'Datoteka mora biti XLSX ali CSV.',
        too_big:           'Datoteka je večja od {mb} MB.',
        preview_failed:    'Datoteke ni bilo mogoče prebrati.',
        failed:            'Inventure ni bilo mogoče ustvariti.',
        from_previous: 'Začne se, kjer se je končala {number} ({date}).',
        period_order: 'Konec obdobja ne sme biti pred začetkom.',
    },
    count: {
        start:                     'Štej',
        progress:                  'Prešteto',
        search:                    'Naziv ali šifra',
        clear_search:              'Počisti iskanje',
        area:                      'Prostor',
        area_placeholder:          'npr. šank, hladilnica',
        filter_all:                'Vsi',
        filter_uncounted:          'Neprešteti',
        filter_counted:            'Prešteti',
        filter_recount:            'Ponovno',
        no_match:                  'Ni zadetkov.',
        empty_filter:              'Na tem seznamu ni artiklov.',
        more:                      'Še {n} — zožite iskanje.',
        not_counted:               'Ni prešteto',
        recount_badge:             'Ponovno preštej',
        added_badge:               'dodan pri štetju',
        recount_alert:             '{n} artikel je treba ponovno prešteti. | {n} artikla je treba ponovno prešteti. | {n} artikle je treba ponovno prešteti. | {n} artiklov je treba ponovno prešteti.',
        entries:                   'Vnosi',
        entries_count:             '{n} vnos | {n} vnosa | {n} vnosi | {n} vnosov',
        mine:                      'moje {quantity}',
        me:                        'jaz',
        counted_total:             'Prešteto skupaj',
        quantity:                  'Količina',
        quantity_required:         'Vpišite količino.',
        note:                      'Opomba',
        code:                      'Šifra',
        unit:                      'EM',
        unit_placeholder:          'kg, kos, l …',
        name:                      'Naziv',
        add:                       'Dodaj',
        added:                     'Dodano: {amount} — {name}',
        add_failed:                'Vnosa ni bilo mogoče dodati.',
        remove_entry:              'Odstrani vnos',
        remove_question:           'Odstranim vnos {quantity} {unit} za {name}?',
        entry_removed:             'Vnos je odstranjen.',
        read_only:                 'Vnosi zdaj niso mogoči.',
        no_permission:             'Za štetje nimate pravice.',
        not_counting:              'Inventura ni več v štetju ({status}); vnosi niso mogoči.',
        open_summary:              'Odpri povzetek',
        new_item:                  'Dodaj artikel, ki ga ni na seznamu',
        new_item_title:            'Artikel, ki ga ni na seznamu',
        new_item_help:             'Najden za šankom, a ga ni na seznamu lokala.',
        code_on_list:              '{code} je že na seznamu — odpiram ga.',
        submit:                    'Zaključi štetje',
        submit_confirm:            'Predaj v pregled',
        submit_question:           'Vsi artikli so prešteti. Predam inventuro v pregled? Štetja potem ni več mogoče dopolnjevati.',
        submit_question_uncounted: 'Nepreštetih je še {n} od {total} artiklov. Vseeno predam inventuro v pregled?',
        submitted:                 'Inventura je predana v pregled.',
        submit_failed:             'Inventure ni bilo mogoče predati v pregled.',
    },
    review: {
        created_by:                 'odprl {name}, {when}',
        to_counting_screen:         'Štetje',
        download:                   'Prenesi Excel',
        download_all:               'Vsi artikli',
        download_differences:       'Samo razlike',
        cancel:                     'Prekliči inventuro',
        cancel_title:               'Prekliči inventuro {number}',
        cancel_help:                'Preklicana inventura ostane zapisana, a ne šteje. Lokal lahko nato dobi novo.',
        back_to_counting:           'Vrni v štetje',
        back_to_counting_question:  'Inventuro vrnem v štetje? Števci bodo videli artikle, označene za ponovno štetje ({n}).',
        close:                      'Zaključi',
        close_question_full:        'Zaključim inventuro? Polna inventura: neprešteti artikli ({n}) se štejejo kot 0. Zaključena inventura je zaklenjena.',
        close_question_partial:     'Zaključim inventuro? Delna inventura: neprešteti artikli ({n}) se izpustijo iz rezultata. Zaključena inventura je zaklenjena.',
        reopen:                     'Ponovno odpri',
        reopen_question:            'Zaključeno inventuro vrnem v pregled?',
        done_back_to_counting:      'Inventura je spet v štetju.',
        done_close:                 'Inventura je zaključena.',
        done_reopen:                'Inventura je spet v pregledu.',
        done_cancel:                'Inventura je preklicana.',
        step_failed:                'Koraka ni bilo mogoče izvesti.',
        cancelled_title:            'Preklical {name}, {when}',
        closed_title:               'Zaključil {name}, {when}',
        counting_title:             'Štetje poteka',
        counting_help:              'Vnosi števcev se tu prikazujejo sproti. Ko števci zaključijo, je inventura v pregledu.',
        submitted_title:            'V pregled predal {name}, {when}',
        stat_counted:               'Prešteto',
        stat_uncounted:             'nepreštetih {n}',
        stat_differences:           'Razlik',
        stat_recount:               'ponovno štetje: {n}',
        stat_difference_value:      'Vrednost razlike',
        stat_book_value:            'Knjižna vrednost',
        stat_counted_value:         'prešteto {value}',
        stat_counters:              'Števci',
        items_title:                'Artikli',
        shown:                      '{n} od {total}',
        filter_all:                 'Vsi',
        filter_differences:         'Samo razlike',
        filter_uncounted:           'Neprešteti',
        filter_recount:             'Ponovno štetje',
        code:                       'Šifra',
        name:                       'Naziv',
        unit:                       'EM',
        book:                       'Knjižno',
        counted:                    'Prešteto',
        difference:                 'Razlika',
        price:                      'Cena',
        difference_value:           'Vr. razlike',
        entries:                    'Vnosi',
        recount:                    'Ponovno',
        recount_of:                 'Ponovno štetje, {code}',
        expand:                     'Pokaži vnose',
        uncounted_full:             '0 ob zaključku',
        uncounted_partial:          'izpuščen',
        no_entries:                 'Ni vnosov.',
        manager_note:               'Opomba',
        manager_note_placeholder:   'Zakaj se razlikuje, kaj je bilo najdeno …',
        remove_entry_question:      'Odstranim vnos {quantity} {unit} ({name})?',
        correction_title:           'Popravek štetja',
        correction_of:              'Popravek štetja, {code}',
        correction_help:            'Doda vnos k preštetemu. Previsoko štetje popravite tako, da v vrstici artikla odstranite napačen vnos.',
        correction_added:           'Popravek je dodan.',
        article: 'Artikel',
        opening: 'Začetno',
        added: 'Dodatno',
        sold: 'Prodaja',
        result: 'Rezultat',
        formula: 'Rezultat = (Popis + Prodaja) − (Začetno + Dodatno)',
        shortage: 'Manjko',
        surplus: 'Višek',
        filter_no_sales: 'Brez prodaje',
        stat_shortage: 'Manjko',
        stat_surplus: 'Višek',
        stat_items_sum: 'skupaj {sum}',
        stat_sales: 'S prodajo',
        stat_no_sales: 'uvozite prodajo',
        sold_of: 'Prodaja, {name}',
        added_of: 'Dodatno, {name}',
        has_correction: 's popravkom',
        added_help: 'Prejeti prenosi v lokal minus izdani iz lokala v obdobju, s popravkom.',
        added_transfers: 'Prenosi',
        no_transfers: 'V obdobju ni prenosov tega artikla.',
        transfer_from: 'iz {place}',
        transfer_to: 'v {place}',
        added_transfers_total: 'Prenosi skupaj',
        correction: 'Popravek',
        correction_help_added: 'Prišteje se k prenosom (negativno odšteje).',
        correction_note_placeholder: 'Zakaj popravek …',
        correction_note_required: 'Popravek potrebuje opombo.',
        correction_saved: 'Popravek je shranjen.',
        transfers_title: 'Prenosi v obdobju',
        transfers_subtitle: 'Prenosnice, ki štejejo v Dodatno.',
        transfer_in: 'prejeto',
        transfer_out: 'izdano',
        transfers_window: 'Prejeti in izdani med {from} in {to}; štejejo v Dodatno.',
        unmatched_alert: '{n} ime iz blagajne še ni povezano z artiklom. | {n} imeni iz blagajne še nista povezani z artiklom. | {n} imena iz blagajne še niso povezana z artiklom. | {n} imen iz blagajne še ni povezanih z artiklom.',
        unmatched_action: 'Poveži imena',
        opening_of: 'Začetno, {name}',
    },
    article: {
        title:               'Artikli šanka',
        subtitle:            'Artikli, ki gredo skozi šanke — seznam vsakega lokala v vrstnem redu popisnega lista.',
        tab_place:           'Po lokalih',
        tab_all:             'Vsi artikli',
        place:               'Lokal',
        place_pick:          'Izberite lokal',
        no_bar_places:       'Noben lokal nima šanka (Šifranti → Skladišča).',
        search:              'Išči artikel',
        add_existing:        'Dodaj obstoječi artikel',
        add:                 'Nov artikel',
        edit:                'Uredi artikel',
        on_list:             '{n} artikel | {n} artikla | {n} artikli | {n} artiklov',
        place_empty:         'Lokal še nima seznama. Dodajte artikle ali uvozite popisni list.',
        add_in_group:        'Nov artikel v skupini {group}',
        move_up:             'Premakni gor: {name}',
        move_down:           'Premakni dol: {name}',
        move_to:             'Premakni na mesto: {name}',
        move_to_title:       'Premakni na mesto',
        position:            'Mesto',
        move:                'Premakni',
        remove_from_place:   'Odstrani s seznama: {name}',
        remove_question:     'Odstranim {name} s seznama tega lokala? Artikel ostane v šifrantu.',
        remove:              'Odstrani s seznama',
        added_to_place:      '{name} je na seznamu.',
        removed_from_place:  '{name} je odstranjen s seznama.',
        name:                'Naziv',
        name_help:           'Kot ga piše blagajna; velike/male črke in šumniki niso pomembni.',
        unit:                'Enota',
        group:               'Skupina',
        code:                'Šifra',
        code_help:           'Neobvezno.',
        add_to_place:        'Dodaj na seznam lokala {place}',
        active_help:         'Neaktivnega artikla ni med izbirami na prenosnicah.',
        name_taken:          'Artikel {name} že obstaja.',
        merge:               'Združi',
        merge_n:             'Združi ({n})',
        merge_hint:          'Za združevanje označite dva ali več zapisov istega artikla.',
        merge_title:         'Združi artikle',
        merge_help:          'Lokali, imena iz blagajne, vrstice prenosnic in inventur se prenesejo na artikel, ki ga obdržite. Tega ni mogoče razveljaviti.',
        merge_keep:          'Obdrži',
        merge_summary:       'V {keep} se združi {n} drug zapis. | V {keep} se združita {n} druga zapisa. | V {keep} se združijo {n} drugi zapisi. | V {keep} se združi {n} drugih zapisov.',
        merged:              'Artikli so združeni v {name}.',
        merge_failed:        'Artiklov ni bilo mogoče združiti.',
        places_count:        '{n} lokal | {n} lokala | {n} lokali | {n} lokalov',
        sales_names_count:   '{n} ime iz blagajne | {n} imeni iz blagajne | {n} imena iz blagajne | {n} imen iz blagajne',
        select:              'Izberi {name}',
        empty:               'Ni artiklov.',
        places:              'Lokali · mesto',
        sales_names:         'Blagajna',
        only_inactive:       'Neaktivni',
        deactivate_question: 'Odstranim artikel {name}? Če je v uporabi, bo le deaktiviran.',
        aliases: 'tudi: {names}',
        merge_max: 'Naenkrat lahko združite največ {n} zapisov.',
        merge_open_inventory: 'Artiklov ni mogoče združiti, ker sta dva na isti odprti inventuri — najprej jo zaključite.',
        dialog_help: 'Naziv, enota, skupina in neobvezna šifra.',
        unit_help: 'Prazno pomeni »kos«.',
    },
    sheet_import: {
        button:          'Uvozi popisni list',
        title:           'Uvozi popisni list',
        description:     'Stolpec artiklov popisnega lista postane seznam lokala v istem vrstnem redu.',
        place:           'Lokal',
        place_pick:      'Izberite lokal',
        file:            'Popisni list',
        file_help:       'Excel (XLSX), kot »Popisni list La Pizzeria …«, največ 10 MB.',
        file_hint:       'XLSX',
        opening:         'Uporabi popis kot začetno stanje',
        opening_help:    'Zadnji stolpec »POPIS ŠANK« postane začetno stanje prve inventure lokala.',
        replaces_list:   'Seznam lokala bo zamenjan z artikli in vrstnim redom iz lista. Znani artikli se povežejo, novi se ustvarijo.',
        done:            'Seznam lokala {place} je uvožen.',
        rows:            'Vrstic',
        linked:          'Povezanih',
        created:         'Novih',
        skipped:         'Preskočenih',
        opening_set:     'Začetno stanje je nastavljeno.',
        opening_set_n:   'Začetno stanje je nastavljeno za {n} artikel. | Začetno stanje je nastavljeno za {n} artikla. | Začetno stanje je nastavljeno za {n} artikle. | Začetno stanje je nastavljeno za {n} artiklov.',
        opening_not_set: 'Začetno stanje ni bilo nastavljeno.',
        wrong_type:      'Popisni list mora biti XLSX.',
        sheet: 'List v datoteki',
        sheet_help: 'Neobvezno — prazno pomeni list z največ podatki.',
        sheet_placeholder: 'npr. Popis',
        sheet_read: 'Prebran list: {sheet}',
    },
    transfer_status: {
        draft:     'Osnutek',
        issued:    'Izdana',
        received:  'Prejeta',
        cancelled: 'Preklicana',
    },
    transfer_status_tab: {
        draft:     'Osnutki',
        issued:    'Izdane',
        received:  'Prejete',
        cancelled: 'Preklicane',
    },
    transfer: {
        list_title:            'Prenosnice',
        list_subtitle:         'Premiki blaga med skladišči in lokali — izda jih pošiljatelj, prejem potrdi prejemnik.',
        new:                   'Nova prenosnica',
        new_title:             'Nova prenosnica',
        edit_title:            'Uredi prenosnico',
        draft_number:          'osnutek',
        place:                 'Lokal',
        all_places:            'Vsi lokali',
        any_article:           'Katerikoli artikel',
        article:               'Artikel',
        empty:                 'Ni prenosnic.',
        limit_hint:            'Prikazanih je zadnjih {n}; zožite filter.',
        number:                'Številka',
        date:                  'Datum',
        route:                 'Od → do',
        lines:                 'Vrstic',
        status:                'Stanje',
        people:                'Kdo',
        created_short:         'pripravil {name}',
        issued_short:          'izdal {name}',
        received_short:        'prejel {name}',
        cancelled_short:       'preklical {name}',
        no_places:             'Ni lokalov za prenos (Šifranti → Skladišča → Prenos) ali jih ne morete brati.',
        from:                  'Od',
        to:                    'Do',
        place_pick:            'Izberite',
        swap:                  'Zamenjaj od in do',
        note:                  'Opomba',
        lines_title:           'Vrstice ({n})',
        article_search:        'Poiščite artikel …',
        search_hint:           'Vpišite nekaj črk imena artikla.',
        search_hint_bar:       'Vpišite nekaj črk; najprej so artikli s seznama {place}.',
        results_target:        'Seznam {place}',
        results_other:         'Drugi artikli',
        results_all:           'Artikli',
        on_note:               'na prenosnici {quantity}',
        quantity:              'Količina',
        quantity_of:           'Količina, {name}',
        line_note:             'Opomba vrstice',
        no_lines:              'Prenosnica še nima vrstic.',
        no_lines_error:        'Dodajte vsaj eno vrstico.',
        remove_line:           'Odstrani vrstico {name}',
        line_summed:           '{name}: skupaj {quantity}',
        quantity_required:     'Vpišite količino.',
        quantity_positive:     'Količina mora biti večja od 0.',
        quantity_not_negative: 'Količina ne sme biti negativna.',
        same_place:            'Od in do morata biti različna lokala.',
        save_draft:            'Shrani osnutek',
        saved:                 'Osnutek je shranjen.',
        save_failed:           'Prenosnice ni bilo mogoče shraniti.',
        saved_as_draft:        'Ostala je shranjena kot osnutek.',
        issue:                 'Izdaj',
        issue_question:        'Izdam prenosnico {from} → {to} ({n} vrstica)? Dobi številko in je ni več mogoče urejati. | Izdam prenosnico {from} → {to} ({n} vrstici)? Dobi številko in je ni več mogoče urejati. | Izdam prenosnico {from} → {to} ({n} vrstice)? Dobi številko in je ni več mogoče urejati. | Izdam prenosnico {from} → {to} ({n} vrstic)? Dobi številko in je ni več mogoče urejati.',
        issued:                'Prenosnica {number} je izdana.',
        issued_print_help:     'Natisnite jo in jo pošljite z blagom; prejemnik potrdi prejem v portalu.',
        issue_failed:          'Prenosnice ni bilo mogoče izdati.',
        leave_question:        'Prenosnica ni shranjena. Zapustim stran in zavržem spremembe?',
        leave:                 'Zavrzi',
        not_draft:             'Urejati je mogoče le osnutek.',
        print:                 'Natisni',
        cancel:                'Prekliči prenosnico',
        cancel_title:          'Prekliči prenosnico {number}',
        cancel_help:           'Preklicana prenosnica ostane zapisana, a ne šteje v inventuro.',
        cancelled_done:        'Prenosnica je preklicana.',
        cancel_failed:         'Prenosnice ni bilo mogoče preklicati.',
        cancelled_title:       'Preklical {name}, {when}',
        waiting_receipt:       'Čaka, da {place} potrdi prejem.',
        receive:               'Potrdi prejem',
        receive_title:         'Potrdi prejem',
        receive_help:          'Vpišite, koliko je v {place} res prispelo; privzeto je poslana količina.',
        receive_confirm:       'Potrdi prejem',
        receive_question:      'Vse je prispelo, kot je bilo poslano. Potrdim prejem?',
        receive_question_diff: '{n} vrstica se razlikuje od poslanega. Potrdim prejem? | {n} vrstici se razlikujeta od poslanega. Potrdim prejem? | {n} vrstice se razlikujejo od poslanega. Potrdim prejem? | {n} vrstic se razlikuje od poslanega. Potrdim prejem?',
        received_done:         'Prejem je potrjen.',
        receive_failed:        'Prejema ni bilo mogoče potrditi.',
        sent_quantity:         'poslano {quantity} {unit}',
        received_of:           'Prejeto, {name}',
        received_quantity:     'prejeto {quantity}',
        receipt_note:          'Opomba ob prejemu',
        receipt_note_help:     'Kaj se razlikuje in zakaj.',
        history:               'Zgodovina',
        history_created:       'Pripravljena',
        history_issued:        'Izdana kot {number}',
        history_received:      'Prejeta v {place}',
        history_cancelled:     'Preklicana',
        lines_count: '{n} vrstica | {n} vrstici | {n} vrstice | {n} vrstic',
        not_own: 'Osnutek lahko ureja in izda le tisti, ki ga je pripravil.',
        first_in_shift: 'Prvi v izmeni na {place}: {name} od {time}',
    },
    print: {
        title:        'PRENOSNICA',
        draft_mark:   'OSNUTEK',
        company:      'Galerija Gosposka d.o.o.',
        company_line: 'Prenos blaga med skladišči',
        from:         'Od (izdajno skladišče)',
        to:           'Do (prejemno skladišče)',
        date:         'Datum',
        no:           'Zap. št.',
        article:      'Artikel',
        unit:         'Enota',
        quantity:     'Količina',
        received:     'Prejeto',
        note:         'Opomba',
        line_count:   'Vrstic: {n}',
        issued_by:    'Izdal:',
        received_by:  'Prejel:',
        at:           '{when}',
        date_sign:    'Datum in podpis',
        footer:       'Prenosnica {number}',
        printed:      'Natisnjeno {when}',
    },
    sales_field: {
        name:     'Naziv',
        quantity: 'Količina',
    },
    sales: {
        button:          'Uvozi prodajo',
        title:           'Uvozi prodajo',
        description:     'Izvoz prodaje iz blagajne za obdobje ({place}); imena se povežejo z artikli lokala.',
        file:            'Izvoz prodaje',
        file_help:       'Excel (XLSX) ali CSV, največ 10 MB.',
        preview_title:   'Prvih {shown} vrstic (glava v vrstici {row})',
        mapping_help:    'Kateri stolpec je naziv artikla in kateri prodana količina.',
        column_pick:     'Izberite stolpec',
        replaces:        'Ponoven uvoz zamenja dosedanje prodane količine.',
        import:          'Uvozi',
        failed:          'Prodaje ni bilo mogoče uvoziti.',
        matched:         'Povezanih imen',
        unmatched:       'Nepovezanih',
        unmatched_title: 'Imena iz blagajne brez artikla',
        unmatched_help:  'Povežite ime z artiklom lokala (zapomni se za naslednjič in prišteje količino) ali ga prezrite.',
        quantity:        'prodano {quantity}',
        article_pick:    'Izberite artikel',
        link:            'Poveži',
        ignore:          'Prezri',
        ignored:         'prezrto',
        link_failed:     'Imena ni bilo mogoče povezati.',
        later:           'Dokončam pozneje',
        sets_all: 'Uvoz nastavi prodajo vsem artiklom — 0 tistim, ki jih izvoz ne omenja, tudi ročno vpisanim.',
    },
    schedule: {
        week_title:            'Teden {n}',
        previous:              'Prejšnji teden',
        next:                  'Naslednji teden',
        this_week:             'Ta teden',
        today:                 'danes',
        draft:                 'Osnutek',
        published:             'Objavljen',
        published_by:          'Objavil {name}, {when}',
        publish:               'Objavi',
        publish_question:      'Objavim urnik za teden {n}? Videli ga bodo vsi zaposleni.',
        published_done:        'Urnik je objavljen.',
        publish_failed:        'Urnika ni bilo mogoče objaviti.',
        copy_previous:         'Kopiraj iz prejšnjega tedna',
        copy_question:         'Kopiram izmene tedna {n} na prazne dni tega tedna? Že vpisane izmene ostanejo.',
        copy:                  'Kopiraj',
        copied:                'Izmene prejšnjega tedna so kopirane na prazne dni.',
        copy_failed:           'Prejšnjega tedna ni bilo mogoče kopirati.',
        print:                 'Natisni',
        excel:                 'Excel',
        not_published:         'Urnik za ta teden še ni objavljen.',
        draft_help:            'Osnutek — zaposleni ga še ne vidijo. Ko je pripravljen, ga objavite.',
        employee:              'Zaposleni',
        hours_short:           'Ure',
        day_hours:             '{hours} h',
        no_employees:          'Ni zaposlenih. Dodajte jih v Urniki → Zaposleni.',
        nobody:                'Ta dan ni nihče razporejen.',
        add_shift:             'Dodaj izmeno',
        edit_day:              'Uredi dan',
        edit_shift_of:         'Uredi izmeno: {name}, {day}',
        inventory_place:       'Popis šanka: {place}',
        day_note:              'Opomba dneva',
        day_note_help:         'Npr. POPIS — izpiše se v glavi dneva.',
        inventory_places:      'Popis šanka ta dan',
        inventory_places_help: 'Tedenski popis (inventura) teh lokalov; vsi v izmeni tam dobijo opomnik na Pregledu.',
        inventory_places_none: 'Brez popisa',
        summary:               'Ure v tednu',
        summary_subtitle:      'Skupaj {hours} h',
        day_total:             'Skupaj',
        week_total:            'Teden',
        copied_count: 'Kopiranih izmen: {copied}; že vpisanih ostalo: {kept}.',
        copy_skipped: '{n} izmena ni prestala preverjanj in ni kopirana. | {n} izmeni nista prestali preverjanj in nista kopirani. | {n} izmene niso prestale preverjanj in niso kopirane. | {n} izmen ni prestalo preverjanj in niso kopirane.',
        on_call:               'Po potrebi (pripravljenost)',
        on_call_plus:          '+{hours} h pp',
        on_call_reserved:      'Pripravljenost — ni vpoklican',
        on_call_present:       'Vpoklican – bil prisoten',
        mark_present:          'Označi kot prisoten',
        unmark_present:        'Odznači',
        on_call_of:            'Pripravljenost {time}: {name}',
        called_in_saved:       '{name} je označen kot prisoten.',
        called_in_cleared:     'Prisotnost za {name} je odznačena.',
        called_in_failed:      'Prisotnosti ni bilo mogoče spremeniti.',
    },
    shift: {
        mode_shift:      'Izmena',
        mode_status:     'Cel dan',
        segment:         'Del {n}',
        no_segments:     'Brez izmene. Dodajte del ali shranite prazno, da dan počistite.',
        start:           'Začetek',
        end:             'Konec',
        next_day:        '(+1)',
        position:        'Delovno mesto',
        place:           'Lokal',
        pick:            'Izberite',
        add_segment:     'Dodaj del izmene',
        remove_segment:  'Odstrani del',
        status:          'Status dneva',
        no_statuses:     'Ni statusov. Dodajte jih v Nastavitve → Urniki.',
        note:            'Opomba',
        copy_to:         'Enako tudi na',
        copy_to_help:    'Isti dan se zapiše še na izbrane dni tega tedna (prepiše, kar je tam).',
        hours:           '{hours} h',
        total:           'Skupaj',
        clear:           'Počisti dan',
        clear_question:  'Počistim dan {day} za {name}?',
        last_edited:     'Nazadnje uredil {name}, {when}',
        problem_order:   'Konec mora biti za začetkom.',
        problem_overlap: 'Prekriva se z drugim delom.',
        problem_outside: 'Konec je po koncu dneva.',
        saved_days:      'Shranjeno za {n} dan. | Shranjeno za {n} dneva. | Shranjeno za {n} dni. | Shranjeno za {n} dni.',
        on_call:         'Pripravljenost (po potrebi)',
        on_call_help:    'Oseba pride le, če jo pokličejo; ure se štejejo šele, ko je vpoklicana.',
        called_in:       'Vpoklican – bil prisoten',
        on_call_plus:    '+{hours} h pp',
        called_in_needs_on_call: 'Vpoklican je lahko le del v pripravljenosti.',
    },
    schedule_print: {
        mark_on_call:   'PP',
        mark_called_in: 'PP✓',
        title:     'URNIK',
        subtitle:  'Razpored izmen',
        inventory: 'Popis šanka: {places}',
        legend:    'Legenda',
        on_call:   'Po potrebi (pripravljenost)',
        called_in: 'Vpoklican – bil prisoten',
    },
    my_schedule: {
        title:           'Moj urnik',
        subtitle:        'Objavljene izmene od {from} do {to}.',
        whole_week:      'Cel teden',
        today:           'Danes',
        tomorrow:        'Jutri',
        empty:           'V objavljenih urnikih za te dni nimate izmen.',
        not_linked:      'Vaš račun ni povezan z nobenim zaposlenim v urniku.',
        not_linked_help: 'Urednik urnikov vas poveže v Urniki → Zaposleni.',
        on_call:         'Pripravljenost',
        on_call_help:    'Pridete le, če vas pokličejo.',
        called_in:       'Vpoklican',
    },
    employee: {
        title:           'Zaposleni',
        subtitle:        'Vrstice urnika v vrstnem redu lista; povezava z računom portala prikaže »Moj urnik«.',
        search:          'Išči zaposlenega',
        show_inactive:   'Prikaži neaktivne',
        empty:           'Ni zaposlenih.',
        add:             'Dodaj zaposlenega',
        edit:            'Uredi zaposlenega',
        name:            'Ime',
        account:         'Račun portala',
        account_help:    'Račun, s katerim se oseba prijavi; vsak račun je lahko povezan le z eno osebo.',
        account_none:    'Brez računa',
        linked:          'povezan',
        home:            'Matično mesto',
        home_help:       'Prosto besedilo kot v stolpcu lista (npr. Rožmarin, sprejem, praksa).',
        active:          'Aktiven',
        active_help:     'Neaktiven zaposleni se v urniku ne riše več (razen v tednih, ko ima izmene).',
        state:           'Stanje',
        move_up:         'Premakni gor',
        move_down:       'Premakni dol',
        order_help:      'Med iskanjem vrstnega reda ni mogoče spreminjati.',
        remove:          'Odstrani',
        remove_question: 'Odstranim {name} iz urnika? Kdor že ima izmene, se le deaktivira.',
        removed:         '{name} je odstranjen iz urnika.',
    },
    settings_urniki: {
        title:               'Urniki',
        subtitle:            'Delovna mesta, statusi dneva in časovna mreža dneva. Barve lokalov se urejajo v Šifranti → Skladišča.',
        positions:           'Delovna mesta',
        positions_help:      'Črka, ki se v urniku izpiše na začetku izmene, ime in barva.',
        add_position:        'Dodaj delovno mesto',
        positions_required:  'Vsaj eno delovno mesto.',
        statuses:            'Statusi dneva',
        statuses_help:       'Cel dan, ki ni izmena (dopust, bolniška …), z barvo pasu v urniku.',
        add_status:          'Dodaj status',
        no_statuses:         'Ni statusov.',
        code:                'Črka',
        code_is:             'Oznaka: {code}',
        name:                'Ime',
        color:               'Barva',
        color_invalid:       'Barva mora biti v obliki #RRGGBB.',
        codes_duplicate:     'Vsaka črka je lahko le enkrat.',
        names_duplicate:     'Vsak status je lahko le enkrat.',
        status_code_invalid: 'Ime mora vsebovati vsaj eno črko ali številko.',
        day:                 'Dan v urniku',
        day_help:            'Začetek in konec mreže; izmene se vpisujejo na {minutes} minut.',
        day_start:           'Začetek dneva',
        day_end:             'Konec dneva',
        day_end_help:        'Pred začetkom pomeni naslednje jutro (npr. 03:00).',
        day_empty:           'Konec mora biti drugačen od začetka.',
        code_of:           'Črka, vrstica {n}',
        position_name_of:  'Ime delovnega mesta, vrstica {n}',
        position_color_of: 'Barva delovnega mesta, vrstica {n}',
        status_name_of:    'Ime statusa, vrstica {n}',
        status_color_of:   'Barva statusa, vrstica {n}',
        on_call:             'Pripravljenost',
        on_call_help:        'Barva časa v pripravljenosti (po potrebi): v urniku je svetlejši in črtkan, dokler oseba ni vpoklicana.',
        on_call_color:       'Barva pripravljenosti',
    },
    color: {
        none:        'brez barve',
        placeholder: '#RRGGBB',
        hex:         'Barva (hex)',
        clear:       'Brez barve',
        invalid: 'Vpišite barvo kot #RRGGBB.',
    },
    user: {
        title:                   'Uporabniki',
        subtitle:                'Lokalni računi, njihove vloge in skladišča.',
        search:                  'Išči uporabnika',
        show_inactive:           'Prikaži neaktivne',
        empty:                   'Ni uporabnikov.',
        add:                     'Dodaj uporabnika',
        edit:                    'Uredi uporabnika',
        username:                'Uporabniško ime',
        username_help:           'Male črke, številke, pika, podčrtaj ali vezaj (2–40 znakov). Kasneje se ne spremeni.',
        username_fixed:          'Uporabniškega imena ni mogoče spremeniti.',
        username_invalid:        'Le male črke, številke, . _ - (2–40 znakov).',
        username_taken:          'To uporabniško ime je že zasedeno.',
        name:                    'Ime in priimek',
        email:                   'E-pošta',
        password:                'Začetno geslo',
        password_help:           'Vsaj {n} znakov. Uporabnik ga ob prvi prijavi zamenja.',
        new_password:            'Novo geslo',
        roles:                   'Vloge',
        roles_pick:              'Izberite vloge',
        warehouses:              'Enote',
        warehouses_all:          'Vse enote',
        warehouses_help:         'Prazno pomeni vse; sicer vidi le dobavnice, inventure in prenose izbranih enot in njihovih mest (Rožmarin: tudi Vinoteka, Glavno skladišče …) ter dobavnice brez enote.',
        warehouses_unavailable:  'Ni še nobenega skladišča.',
        active:                  'Aktiven',
        inactive:                'Neaktiven',
        active_help:             'Neaktiven uporabnik se ne more prijaviti; odprta seja se konča takoj.',
        state:                   'Stanje',
        must_change:             'Mora zamenjati geslo',
        last_login:              'Zadnja prijava',
        never:                   'nikoli',
        you:                     'vi',
        no_access:               'Brez dostopa',
        reset_password:          'Ponastavi geslo',
        reset_password_title:    'Novo geslo za {name}',
        reset_password_help:     'Uporabnik bo moral geslo ob naslednji prijavi zamenjati.',
        password_reset_done:     'Geslo za {name} je ponastavljeno.',
        password_reset_failed:   'Gesla ni bilo mogoče ponastaviti.',
        deactivate:              'Deaktiviraj',
        deactivate_question:     'Deaktiviram uporabnika {name}? Takoj bo odjavljen in se ne bo mogel prijaviti.',
        deactivated:             '{name} je deaktiviran.',
        cannot_deactivate_self:  'Sebe ne morete deaktivirati.',
        reactivate:              'Ponovno aktiviraj',
        reactivated:             '{name} je spet aktiven.',
    },
    role: {
        title:            'Vloge',
        subtitle:         'Vloga je poimenovan nabor pravic; pravice uporabnika so unija njegovih vlog.',
        empty:            'Ni vlog.',
        add:              'Dodaj vlogo',
        edit:             'Uredi vlogo',
        view:             'Prikaži vlogo',
        name:             'Naziv',
        description:      'Opis',
        permissions:      'Pravice',
        permissions_help: 'Vsaka pravica modula vključuje tudi vpogled v ta modul.',
        user_count:       'Uporabnikov',
        system:           'sistemska',
        locked_help:      'Skrbnik ima vedno vse pravice; vloge ni mogoče spremeniti.',
        all:              'Vse',
        none:             'Nobene',
        name_taken:       'Vloga s tem nazivom že obstaja.',
        delete_question:  'Izbrišem vlogo {name}?',
        in_use:           'Vloge ni mogoče izbrisati, dokler jo ima kakšen uporabnik.',
        system_no_delete: 'Sistemske vloge ni mogoče izbrisati.',
        used_no_delete:   'Ima jo {n} uporabnik. | Imata jo {n} uporabnika. | Imajo jo {n} uporabniki. | Ima jo {n} uporabnikov.',
    },
    settings: {
        tab_ai:        'AI',
        tab_dobavnice: 'Izvoz dobavnic',
        tab_share:     'Skener (mapa)',
        tab_inventura: 'Inventura',
        tab_urniki: 'Urniki',
        tab_mail:    'Pošta',
        tab_eracuni: 'E-računi',
    },
    settings_ai: {
        title:               'Branje z AI',
        subtitle:            'Claude (Anthropic) prebere skene; preverjanja in ujemanja naredi strežnik.',
        enabled:             'Branje vklopljeno',
        enabled_help:        'Izklopljeno: nova nalaganja čakajo v vrsti.',
        key:                 'Ključ API Anthropic',
        key_help:            'Ključ se shrani šifrirano in se ne prikaže nikoli več.',
        key_kept_help:       'Shranjeni ključ ostane, dokler ga ne zamenjate ali odstranite.',
        key_remove_help:     'Ključ bo odstranjen ob shranjevanju; branje se ustavi.',
        key_stored:          'Ključ shranjen (…{hint})',
        key_replace:         'Zamenjaj',
        key_remove:          'Odstrani',
        key_will_remove:     'Ključ bo odstranjen',
        key_show:            'Pokaži ključ',
        key_hide:            'Skrij ključ',
        model:               'Model',
        max_concurrent:      'Hkratna branja',
        max_concurrent_help: 'Koliko datotek se bere hkrati (1–4).',
        test:                'Preizkusi povezavo',
        test_ok:             'Povezava deluje: {model}, {ms} ms.',
        test_failed:         'Povezava ne deluje.',
    },
    settings_export: {
        title:               'Izvoz dobavnic (XML)',
        subtitle:            'Oblika datoteke za računovodstvo; več vrednosti še potrjuje računovodstvo.',
        own_tax_id:          'Naša davčna številka',
        own_tax_id_help:     'Kupec na vsakem dokumentu; nikoli se ne vzame za dobavitelja.',
        vrsta_prometa:       'VrstaPrometa',
        vrsta_prometa_help:  'Vrednost polja VrstaPrometa v izvozu.',
        encoding:            'Kodiranje',
        decimal_separator:   'Decimalno ločilo',
        separator_dot:       'pika (126.5)',
        separator_comma:     'vejica (126,5)',
        amount_decimals:     'Decimalke zneskov',
        quantity_decimals:   'Decimalke količin',
        sum_tolerance:       'Dovoljeno odstopanje vsote',
        sum_tolerance_help:  'Največja razlika med vsoto vrstic in neto zneskom dokumenta.',
        vat_groups:          'Skupine DDV',
        vat_groups_help:     'Stopnja DDV → GrupaDdv v izvozu.',
        vat_add:             'Dodaj stopnjo',
        vat_rate_of:         'Stopnja DDV, vrstica {n}',
        vat_code_of:         'Skupina DDV, vrstica {n}',
        vat_duplicate:       'Vsaka stopnja je lahko le enkrat.',
    },
    settings_share: {
        title:                'Skener (mapa v omrežju)',
        subtitle:             'Strežnik pregleduje mape, v katere shranjuje skener — vsaka pripada eni enoti — in vsako novo datoteko naloži kot ročno nalaganje.',
        enabled:              'Samodejni uvoz vklopljen',
        enabled_help:         'Za vklop so potrebni vsaj ena vklopljena mapa, uporabnik in geslo.',
        path:                 'Mapa v skupni rabi',
        folders:              'Mape skenerja',
        folders_help:         'Na primer {example}. Dobavnica iz mape dobi njeno enoto, ne glede na naslov na dokumentu; brez enote jo strežnik ugane po naslovu.',
        folders_empty:        'Ni nobene mape.',
        folder_add:           'Dodaj mapo',
        folder_pick:          'Dodaj s strežnika',
        folder_unit:          'Enota',
        folder_no_unit:       'Brez enote (po naslovu)',
        folder_enabled:       'Vklopljena',
        folder_remove:        'Odstrani mapo',
        folder_twice:         'Mapa je na seznamu dvakrat.',
        folder_test_ok:       'Deluje: čaka {n} sken. | Deluje: čakata {n} skena. | Deluje: čakajo {n} skeni. | Deluje: čaka {n} skenov.',
        path_invalid:         'Pot v obliki \\\\strežnik\\mapa\\podmapa.',
        username:             'Uporabnik',
        username_help:        'Oblike: {forms}.',
        form_user:            'uporabnik',
        form_domain:          'domena',
        domain:               'Domena',
        domain_help:          'Samo za uporabnika brez domene; prazno za račun strežnika samega.',
        password:             'Geslo',
        password_help:        'Geslo se shrani šifrirano in se ne prikaže nikoli več.',
        password_kept_help:   'Shranjeno geslo ostane, dokler ga ne zamenjate ali odstranite.',
        password_remove_help: 'Geslo bo odstranjeno ob shranjevanju; uvoz se ustavi.',
        password_stored:      'Geslo shranjeno',
        password_replace:     'Zamenjaj',
        password_remove:      'Odstrani',
        password_will_remove: 'Geslo bo odstranjeno',
        password_show:        'Pokaži geslo',
        password_hide:        'Skrij geslo',
        processed_folder:     'Mapa za obdelane',
        processed_help:       'Podmapa, v katero se premakne vsaka prevzeta datoteka (tudi že naložena).',
        failed_folder:        'Mapa za zavrnjene',
        failed_help:          'Podmapa za datoteke, ki jih portal zavrne (ni PDF, JPG ali PNG, večja od 25 MB, prazna).',
        folder_invalid:       'Ime mape ne sme vsebovati znakov {chars}.',
        folders_differ:       'Mapi morata biti različni.',
        poll_minutes:         'Pregled vsakih (min)',
        poll_help:            'Od 1 do 60 minut.',
        min_age:              'Najmanjša starost datoteke (s)',
        min_age_help:         'Mlajše datoteke počakajo na naslednji pregled — skener jih morda še zapisuje.',
        test:                 'Preizkusi povezavo',
        test_help:            'Preizkus uporabi shranjene nastavitve: v vsaki mapi se poveže, prešteje skene in ustvari manjkajoči podmapi; ponudi tudi sosednje mape prve. Ničesar ne premakne.',
        test_ok:              'Povezava deluje: v mapah čaka {n} sken. | Povezava deluje: v mapah čakata {n} skena. | Povezava deluje: v mapah čakajo {n} skeni. | Povezava deluje: v mapah čaka {n} skenov.',
        test_failed:          'Povezava ne deluje.',
        test_save_first:      'Najprej shranite spremembe — preizkus uporabi shranjene nastavitve.',
        test_folders_failed:  'Povezava deluje, podmap pa ni mogoče ustvariti.',
    },
    settings_mail: {
        title:                'Pošta (odhodna)',
        subtitle:             'Račun SMTP, s katerim portal pošilja e-pošto — najprej E-račune, pozneje obvestila.',
        host:                 'Strežnik SMTP',
        host_help:            'Ime ali naslov strežnika, brez protokola.',
        host_invalid:         'Samo ime ali naslov strežnika (brez presledkov, poševnic in {\'@\'}).',
        security:             'Zaščita',
        security_starttls:    'STARTTLS (587)',
        security_tls:         'TLS (465)',
        security_none:        'Brez šifriranja',
        port:                 'Vrata',
        username:             'Uporabnik',
        username_help:        'Prazno: strežnik ne zahteva prijave.',
        password:             'Geslo',
        password_help:        'Geslo se shrani šifrirano in se ne prikaže nikoli več.',
        password_kept_help:   'Shranjeno geslo ostane, dokler ga ne zamenjate ali odstranite.',
        password_remove_help: 'Geslo bo odstranjeno ob shranjevanju.',
        password_stored:      'Geslo shranjeno',
        password_replace:     'Zamenjaj',
        password_remove:      'Odstrani',
        password_will_remove: 'Geslo bo odstranjeno',
        password_show:        'Pokaži geslo',
        password_hide:        'Skrij geslo',
        from_address:         'Naslov pošiljatelja',
        from_address_help:    'Naslov v polju From; strežnik mora dovoliti pošiljanje z njim.',
        from_name:            'Ime pošiljatelja',
        plain_warning:        'Brez šifriranja portal pošilja le na strežnik v zasebnem omrežju, geslo pa samo na localhost.',
        test_title:           'Preizkusno sporočilo',
        test_help:            'Pošlje kratko sporočilo s shranjenimi nastavitvami na naslov, ki ga vpišete.',
        test_to:              'Prejemnik preizkusa',
        test:                 'Pošlji preizkusno sporočilo',
        test_ok:              'Sporočilo je poslano na {to}.',
        test_failed:          'Sporočila ni bilo mogoče poslati.',
        test_save_first:      'Najprej shranite spremembe — preizkus uporabi shranjene nastavitve.',
    },
    settings_eracuni: {
        title:                     'E-računi',
        subtitle:                  'Strežnik pregleduje mapo prejetih e-računov in vsako novo datoteko pošlje po e-pošti v sprejem e-računov.',
        enabled:                   'Pošiljanje vklopljeno',
        enabled_help:              'Za vklop so potrebni pot, račun za mapo in nastavljena odhodna pošta (Nastavitve → Pošta).',
        path:                      'Mapa v skupni rabi',
        path_help:                 'Na primer {example}. Strežnik vzame le datoteke v sami mapi, ne v podmapah.',
        path_required:             'Za vklop je pot obvezna.',
        use_scanner_account:       'Uporabi račun skenerja',
        use_scanner_account_help:  'Uporabnik in geslo iz zavihka Skener (mapa); izklopljeno: lasten račun za to mapo.',
        to:                        'Prejemnik',
        to_help:                   'Naslov sprejema e-računov; vsaka datoteka gre v svojem sporočilu.',
        subject:                   'Zadeva',
        body:                      'Besedilo',
        template_help:             '{\'{file}\'} se zamenja z imenom datoteke.',
        sent_folder:               'Mapa za poslane',
        sent_folder_help:          'Podmapa, v katero se premakne poslana datoteka (tudi že prej poslana).',
        failed_folder:             'Mapa za neuspele',
        failed_folder_help:        'Podmapa za datoteke, večje od 25 MB, prazne ali neposlane po vseh poskusih.',
        min_age_help:              'Mlajše datoteke počakajo na naslednji pregled — morda se še zapisujejo.',
        extensions:                'Končnice',
        extensions_help:           'Le datoteke s temi končnicami (brez pike), npr. pdf, xml.',
        extensions_add:            'Dodaj končnico …',
        extensions_invalid:        'Končnica so le črke in številke (1–10), npr. pdf.',
        max_attempts:              'Največ poskusov',
        max_attempts_help:         'Po toliko neuspelih pošiljanjih gre datoteka v mapo za neuspele.',
        test_help:                 'Preizkus uporabi shranjene nastavitve: se poveže, prešteje datoteke in ustvari manjkajoči podmapi. Ničesar ne premakne in ne pošlje.',
        test_ok:                   'Povezava deluje: v mapi čaka {n} datoteka. | Povezava deluje: v mapi čakata {n} datoteki. | Povezava deluje: v mapi čakajo {n} datoteke. | Povezava deluje: v mapi čaka {n} datotek.',
    },
    eracuni_status: {
        sent:      'Poslano',
        duplicate: 'Že poslano',
        failed:    'Ni uspelo',
        gave_up:   'Opuščeno',
        refused:   'Zavrnjeno',
    },
    eracuni: {
        title:            'Dnevnik e-računov',
        subtitle:         'Vsaka datoteka iz mape e-računov: kaj je bilo poslano, kdaj in kam.',
        settings:         'Nastavitve',
        status_line:      'Pregled mape {path}: zadnji {last}, danes {sent}',
        status_sent:      'poslan {n} | poslana {n} | poslani {n} | poslanih {n}',
        status_failed:    'neuspelih {n}',
        status_waiting:   'v mapi čaka {n}',
        status_never:     'še ni bilo',
        status_off:       'Pošiljanje iz {path} je izklopljeno.',
        status_error:     'Zadnja napaka: {error}',
        search:           'Ime datoteke, SHA-256 ali Message-ID',
        status:           'Stanje',
        all_statuses:     'Vsa stanja',
        from:             'Prebrano od',
        to_date:          'Prebrano do',
        empty:            'Dnevnik je prazen.',
        empty_filtered:   'Nobena datoteka ne ustreza filtru.',
        read_at:          'Prebrano',
        read_at_long:     'Prebrano {at}',
        file:             'Datoteka',
        detail:           'Podrobnosti',
        attempts:         'Poskusi',
        resend_badge:     'ponovno poslano',
        duplicate_detail: 'Ista vsebina je že bila poslana; premaknjeno v {folder}.',
        sent_detail:      'Na {to}, {at}',
        reason:           'Razlog',
        error:            'Odgovor strežnika',
        size:             'Velikost',
        to:               'Prejemnik',
        sent_at:          'Poslano',
        last_attempt:     'zadnji {at}',
        message_id:       'Message-ID',
        moved_to:         'Premaknjeno v',
        not_moved:        'ostaja v mapi',
        duplicate_of:     'Prej poslano',
        resend_of:        'Ponovno poslano',
        resent_by:        'poslal(a) {name}',
        open_earlier:     'Vsi vnosi te vsebine',
        sha256:           'SHA-256',
        no_copy:          'Kopija ni shranjena — datoteka ni bila prebrana.',
        resend:           'Pošlji znova',
        resend_title:     'Ponovno pošiljanje',
        resend_question:  'Shranjena kopija datoteke {name} bo znova poslana prejemniku iz nastavitev E-računov.',
        resent_toast:     '{name} je znova poslan na {to}.',
        resend_failed:    'Datoteke ni bilo mogoče znova poslati.',
    },
    settings_inventura: {
        title:                  'Inventura',
        subtitle:               'Uvoz prodaje iz blagajne in prostori za štetje.',
        mapping:                'Zapomnjena povezava stolpcev prodaje',
        mapping_help:           'Nastavi se ob uvozu prodaje (»Zapomni si povezavo stolpcev«). Brez nje strežnik ugiba po imenih stolpcev.',
        not_set:                'ni nastavljeno',
        mapping_reset:          'Pozabi povezavo',
        mapping_reset_question: 'Pozabim zapomnjeno povezavo stolpcev? Naslednji uvoz bo stolpce ugibal po imenih.',
        areas:                  'Prostori',
        areas_help:             'Predlogi na zaslonu za štetje (npr. šank, hladilnica). Števci lahko vpišejo tudi drug prostor.',
        areas_duplicate:        'Vsak prostor je lahko le enkrat.',
    },
    profile: {
        title:             'Moj profil',
        subtitle:          'Ime, e-pošta in jezik konzole.',
        locale_help:       'Jezik konzole po prijavi.',
        must_change_title: 'Zamenjajte geslo',
        must_change_help:  'Geslo vam je nastavil skrbnik. Preden nadaljujete, si nastavite svoje.',
    },
    password: {
        title:    'Geslo',
        subtitle: 'Za spremembo vpišite trenutno geslo.',
        current:  'Trenutno geslo',
        new:      'Novo geslo',
        repeat:   'Ponovite novo geslo',
        mismatch: 'Gesli se ne ujemata.',
        same:     'Novo geslo mora biti drugačno od trenutnega.',
        change:   'Zamenjaj geslo',
        changed:  'Geslo je zamenjano.',
        failed:   'Gesla ni bilo mogoče zamenjati.',
    },
}

export type MessageSchema = typeof sl

export default sl
